import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Container from "react-bootstrap/esm/Container";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import MyAlert from "../component/MyAlert";
import { DEPLOY_HOST_URL } from "../globalVars";
export default function LoginPage() {
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  // console.log({email, password})

  const localSetLogin = (e) => {
    e.preventDefault();

    if (!email) {
      setErrorMessage("Email is required!");
      setShowAlert(true);
      return;
    }

    if (!password) {
      setErrorMessage("Password is required!");
      setShowAlert(true);
    }

    const obj = {
      email,
      password,
    };
    setLoading(true);
    fetch(DEPLOY_HOST_URL + "/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    })
      .then((response) => {
        // console.log(response)
        if (response.ok) {
          return response.json();
        } else {
          // console.log(response)
          switch (response.status) {
            case 401:
              throw new Error("Wrong email or password!");
            default:
              throw new Error("Internal server error");
          }
        }
      })
      .then((data) => {
        // console.log(data)
        const { access_token } = data;
        localStorage.setItem("access_token", access_token);
        navigate("/");
      })
      .catch((error) => {
        setErrorMessage(error?.message);
        setShowAlert(true);
        return;
      })
      .finally((_) => {
        setLoading(false);
      });
  };

  return (
    <Container className="w-25" style={{ marginTop: "10%" }}>
      <h1>Login</h1>
      {showAlert && <MyAlert title={errorMessage} setShow={setShowAlert} />}
      <Form onSubmit={localSetLogin}>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        <Button variant="primary" type="submit" disabled={loading}>
          {loading && <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              />
              <span className="visually-hidden">Loading...</span>
              &nbsp;
          </>
          }
          {!loading && <span>Submit</span>}
          {loading && <span>Loading ...</span>}
        </Button>
      </Form>
    </Container>
  );
}
